import React, { useState, useEffect } from "react";
import { Link as RouterLink } from "react-router-dom";
import clsx from "clsx";
import moment from "moment";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import Avatar from "@material-ui/core/Avatar";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  colors,
} from "@material-ui/core";

import { Label, TableEditBar } from "../../../../components";

const useStyles = makeStyles((theme) => ({
  root: {},
  filterButton: {
    marginRight: theme.spacing(2),
  },
  content: {
    padding: 0,
  },
  inner: {
    // minWidth: 1150
  },
  actions: {
    padding: theme.spacing(0, 1),
    justifyContent: "flex-end",
  },
}));

const Results = (props) => {
  const { className, orders, ...rest } = props;

  const classes = useStyles();

  const [selectedOrders, setSelectedOrders] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [showpreview, setShowpreview] = useState(false);
  const [previewurl, setpreviewurl] = useState("");
  function previewimage(url) {
    setpreviewurl(url);
    setShowpreview(true);
  }
  const handleSelectAll = (event) => {
    const selectedOrders = event.target.checked
      ? orders.map((order) => order.id)
      : [];

    setSelectedOrders(selectedOrders);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedOrders.indexOf(id);
    let newSelectedOrders = [];

    if (selectedIndex === -1) {
      newSelectedOrders = newSelectedOrders.concat(selectedOrders, id);
    } else if (selectedIndex === 0) {
      newSelectedOrders = newSelectedOrders.concat(selectedOrders.slice(1));
    } else if (selectedIndex === selectedOrders.length - 1) {
      newSelectedOrders = newSelectedOrders.concat(selectedOrders.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedOrders = newSelectedOrders.concat(
        selectedOrders.slice(0, selectedIndex),
        selectedOrders.slice(selectedIndex + 1)
      );
    }

    setSelectedOrders(newSelectedOrders);
  };

  const handleChangePage = (event, page) => {
    setPage(page);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
  };
  useEffect(() => {
    setPage(0);
  }, [orders]);
  const paymentStatusColors = {
    canceled: colors.grey[600],
    pending: colors.orange[600],
    active: colors.green[600],
    inactive: colors.red[600],
  };
  return (
    <>
      {showpreview && (
        <Lightbox
          mainSrc={previewurl}
          onCloseRequest={() => setShowpreview(false)}
          onMovePrevRequest={() => alert("prev")}
          onMoveNextRequest={() => alert("next")}
        />
      )}

      <div {...rest} className={clsx(classes.root, className)}>
        <Card>
          <CardHeader title="Commodity" />
          <Divider />
          <CardContent className={classes.content}>
            <div className={classes.inner}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>S no</TableCell>
                    <TableCell>Image</TableCell>
                    <TableCell>Parent Commodity</TableCell>
                    <TableCell>Name</TableCell>

                    <TableCell>languages</TableCell>
                    <TableCell>status</TableCell>
                    <TableCell>Updated At</TableCell>

                    <TableCell align="center">Edit</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {orders
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((order, index) => {
                      return (
                        <TableRow
                          key={order.id}
                          selected={selectedOrders.indexOf(order.id) !== -1}
                        >
                          <TableCell>
                            {page * rowsPerPage + (index + 1)}
                          </TableCell>

                          <TableCell>
                            <Avatar
                              alt={order.name}
                              src={`${order.imageurl}`}
                              onClick={() => previewimage(order.imageurl)}
                            />
                          </TableCell>
                          <TableCell>
                            {order.mastercommodity
                              ? order.mastercommodity.name
                              : "NA"}
                          </TableCell>
                          <TableCell>{order.name}</TableCell>
                          <TableCell>
                            {order.com_names &&
                              order.com_names.map((role, index) => (
                                <>
                                  <Label
                                    color={
                                      paymentStatusColors[
                                        role?.master_language?.name
                                          ? "active"
                                          : "inactive"
                                      ]
                                    }
                                    variant="outlined"
                                  >
                                    {role?.master_language?.name
                                      ? role?.master_language?.name
                                      : "In Active"}
                                  </Label>

                                  {index % 4 && index > 0 ? <br></br> : null}
                                </>
                              ))}
                          </TableCell>
                          <TableCell>
                            <Label
                              color={
                                paymentStatusColors[
                                  order.status ? "active" : "inactive"
                                ]
                              }
                              variant="contained"
                            >
                              {order.status ? "Active" : "In Active"}
                            </Label>
                          </TableCell>
                          <TableCell>
                            <Typography variant="body1">
                              {moment.utc(order?.updatedAt).local().format(
                                "DD MMM YYYY hh:mm a"
                              )}
                            </Typography>
                          </TableCell>

                          <TableCell align="center">
                            <Button
                              color="primary"
                              component={RouterLink}
                              size="small"
                              to={`/editcommodity/${order.id}`}
                              variant="outlined"
                            >
                              Edit
                            </Button>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </div>
          </CardContent>
          <CardActions className={classes.actions}>
            <TablePagination
              component="div"
              count={orders.length}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
              page={page}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[5, 10, 25,100]}
            />
          </CardActions>
        </Card>
        <TableEditBar selected={selectedOrders} />
      </div>
    </>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  orders: PropTypes.array.isRequired,
};

Results.defaultProps = {
  orders: [],
};

export default Results;